export default [
  {
    path: '/third-pay',
    name: 'thirdPay',
    component: () => import('../../pages/thirdPay/index.vue'),
    meta: {
      title: '发起代付申请'
    }
  },
  {
    path: '/third-pay-share',
    name: 'thirdPayShare',
    component: () => import('../../pages/thirdPay/sharePay.vue'),
    meta: {
      title: '求付款',
      noAuth: true
    }
  }
];
